import { defineStore } from "pinia"
import { ref, type Ref } from "vue"
import { ProductionStatementApproval } from "@/models/production-statement-approval.model"

import { ModelFactory } from "@/factories/model-factory"
import ModelManager from "@/services/model-manager"

export const useProductionStatementApprovalStore = defineStore(
  "productionStatementApprovalStore",
  () => {
    const productionStatementApprovals: Ref<ProductionStatementApproval[]> = ref([])

    const manualDraft: Ref<ProductionStatementApproval | null> = ref(null)

    function restoreManualDraft() {
      const draft = manualDraft.value
      if (
        draft &&
        !draft.isSaved &&
        !productionStatementApprovals.value.some((approval) => approval.id === draft.id)
      ) {
        productionStatementApprovals.value.unshift(draft)
      }
    }

    function openManualDraft(): ProductionStatementApproval {
      if (!manualDraft.value || manualDraft.value.isSaved) {
        manualDraft.value = ModelFactory.createModel(ProductionStatementApproval)
      }
      restoreManualDraft()
      return manualDraft.value
    }

    function discardEmptyDraft(approval: ProductionStatementApproval) {
      if (
        manualDraft.value?.id !== approval.id ||
        approval.isSaved ||
        approval.hasApprovalContent()
      )
        return
      productionStatementApprovals.value = productionStatementApprovals.value.filter(
        (item) => item.id !== approval.id
      )
      ModelManager.getInstance().evict(approval.id!)
      manualDraft.value = null
    }

    return {
      productionStatementApprovals,
      manualDraft,
      openManualDraft,
      restoreManualDraft,
      discardEmptyDraft
    }
  }
)
